import React from "react";
import EquitiesInstrument from "./EquitiesInstrument";
import { classNameForValidationErrors } from "../../common/components/componentUtils";
import { tdStyles } from "../../common/styles";
import Direction from "./Direction";
import RemoveButton from "./RemoveButton";
import Price from "./Price";
import Derivative from "./Derivative";
import { hasNoDerivativeDescription } from "../models";

const EquityRecommendationLeg = (props) => (
    <tr>
        <td style={tdStyles}>
            <Direction {...props.direction} />
        </td>
        <td style={tdStyles}>
             <EquitiesInstrument {...props.instrument}
                                 className={ classNameForValidationErrors(props.instrument) }/>
        </td>
        <td style={tdStyles}>
            <Derivative derivativeDescription={props.derivativeDescription}
                        placeholder="Description" />
        </td>
        <td style={tdStyles}>
            <Price {...props.suppliedPrice}
                   className={`x-market-price ${classNameForValidationErrors(props.suppliedPrice)}`}
                   disabled={hasNoDerivativeDescription(props.derivativeDescription.value)}
                   disabledText="Market price only required for equity derivatives" />
        </td>

        <td style={tdStyles}>
            <Price {...props.targetPrice} />
        </td>
        <td>
            <RemoveButton onClick={props.onRemoveLeg} />
        </td>
    </tr>
);
export default EquityRecommendationLeg;


/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/EquityRecommendationLeg.js
 **/